import React, { PropTypes as RPT } from 'react';
import createHistory from 'history/createBrowserHistory';
import promiseMiddleware from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import { Button, utils } from 'react-bootstrap';
import { Provider } from 'react-redux';
import { createLogger } from 'redux-logger';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';

import createStore from '../common/createStore';

import RouterHandler from './RouteHandler';

const history = createHistory();
const router = routerMiddleware(history);

const middlewares = [
  router,
  thunk,
  promiseMiddleware({
    promiseTypeSuffixes: ['START', 'SUCCESS', 'ERROR']
  })
];

if (process.env.APP_ENV !== 'production') {
  middlewares.push(createLogger({ collapsed: true }));
}

const store = createStore(window.REDUX_STATE || {}, { middlewares });

utils.bootstrapUtils.addStyle(Button, 'instagram');
utils.bootstrapUtils.addStyle(Button, 'facebook');

const BrowserProvider = ({ children }) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <RouterHandler>
        {children}
      </RouterHandler>
    </ConnectedRouter>
  </Provider>
);

BrowserProvider.propTypes = {
  children: RPT.node.isRequired
};

export default BrowserProvider;



// WEBPACK FOOTER //
// ./src/browser/BrowserProvider.react.js